<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_13234_2919)">
      <path
        d="M5.07864 9.35668C5.02685 9.02287 4.99997 8.68089 4.99997 8.33268C4.99997 4.65078 8.00438 1.66602 11.7105 1.66602C15.4166 1.66602 18.421 4.65078 18.421 8.33268C18.421 9.16441 18.2677 9.96056 17.9876 10.6948C17.9295 10.8473 17.9004 10.9235 17.8872 10.983C17.8741 11.042 17.869 11.0835 17.8676 11.1439C17.8662 11.2048 17.8744 11.272 17.891 11.4063L18.2265 14.1315C18.2628 14.4265 18.2809 14.574 18.2319 14.6812C18.1889 14.7752 18.1125 14.8498 18.0176 14.8906C17.9092 14.9372 17.7622 14.9156 17.4681 14.8725L14.8137 14.4834C14.6751 14.4631 14.6058 14.453 14.5427 14.4533C14.4803 14.4537 14.4371 14.4583 14.376 14.4711C14.3142 14.4841 14.2353 14.5137 14.0775 14.5728C13.3414 14.8485 12.5437 14.9993 11.7105 14.9993C11.362 14.9993 11.0197 14.973 10.6856 14.9221M6.35965 18.3327C8.8304 18.3327 10.8333 16.2807 10.8333 13.7493C10.8333 11.218 8.8304 9.16602 6.35965 9.16602C3.88891 9.16602 1.88597 11.218 1.88597 13.7493C1.88597 14.2582 1.9669 14.7476 2.1163 15.205C2.17945 15.3983 2.21102 15.4949 2.22139 15.561C2.2322 15.6299 2.2341 15.6686 2.23007 15.7383C2.22621 15.805 2.20952 15.8804 2.17613 16.0313L1.66667 18.3327L4.16234 17.9918C4.29856 17.9732 4.36667 17.9639 4.42615 17.9643C4.48877 17.9648 4.52201 17.9682 4.58343 17.9804C4.64176 17.992 4.72847 18.0226 4.9019 18.0838C5.35883 18.2451 5.84926 18.3327 6.35965 18.3327Z"
        stroke="#EAF7F6"
        stroke-width="1.67"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_13234_2919">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
